import React from 'react'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'

function Footer({ sendMessage, redirectToProfile, userId, showSendMessage }) {
  return (
    <div className={styles.footerContainer}>
      <button type='button' onClick={redirectToProfile} className={`${styles.profileButton} `}>
        <Icon name='contact' size='large32' />
      </button>
      {showSendMessage && (
        <button type='button' onClick={() => sendMessage(userId)} className={`${styles.messageButton} `}>
          <Icon name='write' size='large32' />
        </button>
      )}
    </div>
  )
}

export default Footer
